import { FlightResult, ItineraryFlightBooking } from '@/travelsuit'

export function getFlightStartTime(flight: FlightResult | ItineraryFlightBooking) {
	const segment = flight.flights[0].segments[0]
	return segment.departure_time ?? segment.departure.datetime
}
